"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var context_state_1 = require("../decorator/context-state");
var irender_reason_1 = require("../interface/irender-reason");
var core_1 = require("../../../core");
var ContextStateTrait = /** @class */ (function () {
    function ContextStateTrait() {
    }
    ContextStateTrait.enableFor = function (instance) {
        var prototype = Object.getPrototypeOf(instance);
        // no @contextState used in target class
        if (!prototype[context_state_1.CONTEXT_STATE_ASSIGNMENTS])
            return;
        for (var _i = 0, _a = prototype[context_state_1.CONTEXT_STATE_ASSIGNMENTS]; _i < _a.length; _i++) {
            var contextStateName = _a[_i];
            core_1.st.addContextChangeHandler(contextStateName, function (change) {
                if (instance.shouldRender(irender_reason_1.RenderReason.STATE_CHANGE, change)) {
                    instance.doRender();
                }
            });
        }
    };
    return ContextStateTrait;
}());
exports.ContextStateTrait = ContextStateTrait;
//# sourceMappingURL=context-state.js.map